import { render } from "./canva_cta_post.vue?vue&type=template&id=03cfc40b&scoped=true"
import script from "./canva_cta_post.vue?vue&type=script&lang=js"
export * from "./canva_cta_post.vue?vue&type=script&lang=js"

import "./canva_cta_post.vue?vue&type=style&index=0&id=03cfc40b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cfc40b"]])

export default __exports__